import Intro from "../../components/intro/Intro";
import Gallery from "../../components/gallery/Gallery";
import WireNameGallery from "../../components/gallery/WireNameGallery";
import Note from "../../components/note/Note";

const Art = () => {
  const woodburnings = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/britain.webp",
      alt: "A close-up shot of a wood burning of a husband and wife looking at each other while holding an intricate bouquet of flowers between them.",
      title: "Wife and Husband",
      date: "2018",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/cover.webp",
      alt: "wedding guest book cover",
      title: "Guest Book Cover",
      date: "2020",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/capone.webp",
      alt: "capone",
      title: "Capone",
      date: "2024",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/potter.webp",
      alt: "harry potter and voldemort",
      title: "Harry and Voldemort",
      date: "2018",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/halo.webp",
      alt: "master chief",
      title: "Master Chief",
      date: "2017",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/jesus.webp",
      alt: "jesus",
      title: "Jesus",
      date: "2018",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/elsa.webp",
      alt: "elsa",
      title: "Elsa",
      date: "2017",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wood_burning/gaten.webp",
      alt: "gaten matarazzo",
      title: "Kid from 'Stranger Things'",
      date: "2017",
    },
  ];

  const logos = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/logo/ccc.webp",
      alt: "a sideways crystal.",
      title: "Crystal Clear Consulting",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/logo/mxm.webp",
      alt: "m with a circle over it",
      title: "Mantle Experience Management",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/logo/hackpack.webp",
      alt: "an abstract infinity symbol with an 'H' hidden inside.",
      title: "HackPack",
    },
    {
      src: "https://storage.googleapis.com/money-bender-media/logos/1000x1000.jpg",
      alt: "The Bendy Budget logo: A white symbol that somewhat resembles the letter 'm' (lowercase) rotated clockwise 45 degrees against a bold orange background. (The 'm' is missing its tail in the top left, and the middle pillar is elongated.)",
      title: "Bendy Budget",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/logo/ss.jpg",
      alt: "a white squid-shaped creature with two 's'-shaped legs against a dark blue and purple background.",
      title: "SquidSlippers",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/logo/releafer.webp",
      alt: "three leaves sprouting from a center point",
      title: "ReLeafer",
    },
  ];

  const claysculptures = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/bobomb.webp",
      alt: "bob-omb",
      title: "Bob-Omb",
      date: "2023",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/shrek.webp",
      alt: "shrek",
      title: "Shrek",
      date: "2024",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/crow.jpg",
      alt: "crow",
      title: "Crow",
      date: "2025",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/jigglypuff.webp",
      alt: "jigglypuff",
      title: "Jigglypuff",
      date: "2023",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/earrings.webp",
      alt: "earrings",
      title: "Elements of Harmony",
      date: "2022",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/clay/diglett.webp",
      alt: "diglett",
      title: "Diglett",
      date: "2024",
    },
  ];

  const miscellaneous = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/squidward.webp",
      alt: "squidward",
      title: "Bold and Brash",
      date: "2022",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/baylee.webp",
      alt: "baylee",
      title: "Husband and Wife",
      date: "2018",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/olaf.webp",
      alt: "olaf",
      title: "Olaf",
      date: "2020",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/egg.webp",
      alt: "egg",
      title: "Egg",
      date: "2021",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/pearl.webp",
      alt: "pearl",
      title: "Pearl",
      date: "2021",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/pig.webp",
      alt: "pig",
      title: "Pig",
      date: "2019",
    },
  ];

  return (
    <>
      <Intro
        primary="I LOOOOOVE ART"
        secondary="I make, perform, sell, and give away all kinds of art: wood burning, logo design, digital art, painting, sculpting, drawing—you name it, I've (probably) tried it! If you want to explore my gallery..."
        tertiary="You're in the right place."
      />

      <div className="column p01 g1">
        <h2>WIRE NAMES</h2>
        <p className="ctext">
          Using my hands and pliers, I bend rolls of steel and copper wire into
          custom luxury wire names.
        </p>
        <WireNameGallery />

        <h2>WOOD BURNING</h2>
        <p className="ctext">
          Pyrography is one of my favorite art forms. I specialize in portraits
          of people and animals.
        </p>
        <Note type="note">
          <p>
            Commissions are closed. Thanks to those who placed an order. I
            estimate they'll reopen around October 2026.
          </p>
        </Note>
        <Gallery pictures={woodburnings} />

        <h2>LOGO DESIGN</h2>
        {/* <h3 className="ltext">LOGOS</h3> */}

        <Gallery pictures={logos} />

        <h2>CLAY</h2>
        <Gallery pictures={claysculptures} isHalf />

        <h2>TRADITIONAL</h2>
        <Gallery pictures={miscellaneous} />
      </div>
    </>
  );
};

export default Art;
